import * as Headless from '@headlessui/react';
import React from 'react';

interface ConfirmState {
  params?: {
    title?: string;
    body?: string;
    confirmText?: string;
  };
}

interface DataGridConfirmModalProps {
  confirmState: ConfirmState | null | undefined;
  confirmProceed: () => void;
  cancelConfirm: () => void;
  themeBorder: string;
  t: (key: string) => string;
}

export function DataGridConfirmModal({
  confirmState,
  confirmProceed,
  cancelConfirm,
  themeBorder,
  t
}: DataGridConfirmModalProps) {
  return (
    <Headless.Transition appear show={!!confirmState} as={React.Fragment}>
      <Headless.Dialog
        as="div"
        className="relative z-50"
        onClose={cancelConfirm}
      >
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Headless.Dialog.Panel
              className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-zinc-900 p-6 text-left align-middle shadow-xl transition-all"
              style={{ border: `1px solid ${themeBorder}` }}
            >
              <Headless.Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-zinc-900 dark:text-zinc-100"
              >
                {confirmState?.params?.title ?? 'Confirm'}
              </Headless.Dialog.Title>

              {confirmState?.params?.body && (
                <div className="mt-2">
                  <p className="text-sm text-zinc-700 dark:text-zinc-300">
                    {confirmState.params.body}
                  </p>
                </div>
              )}

              <div className="mt-4 flex items-center justify-end gap-2">
                <button
                  type="button"
                  className="rounded-2xl px-3 py-1.5 text-sm ring-1 ring-zinc-300 dark:ring-zinc-700 hover:bg-zinc-100 dark:hover:bg-zinc-800"
                  onClick={cancelConfirm}
                >
                  {t('cancel') || 'Cancel'}
                </button>
                <button
                  type="button"
                  className="rounded-2xl px-3 py-1.5 text-sm ring-1 ring-indigo-300 text-indigo-700 dark:ring-indigo-700/60 dark:text-indigo-300 hover:bg-indigo-50/60 dark:hover:bg-indigo-900/20"
                  onClick={confirmProceed}
                >
                  {confirmState?.params?.confirmText ||
                    t('confirm') ||
                    'Confirm'}
                </button>
              </div>
            </Headless.Dialog.Panel>
          </div>
        </div>
      </Headless.Dialog>
    </Headless.Transition>
  );
}
